module.exports = "<div class=\"l-wrapper \">\n    <!-- 03-00-00_cleaners -->\n    <div class=\"c-grid-two-columns\">\n        <cleaners-search (searchCleaners)=\"searchCleaners($event)\" class=\"c-grid-two-columns__column\"></cleaners-search>\n        <cleaners-create (submitCleaner)=\"createCleaner($event)\" class=\"c-grid-two-columns__column\"></cleaners-create>\n    </div>\n   \n    <cleaners-list *ngIf=\"cleaners.length != 0\" [cleaners]=\"cleaners\"> </cleaners-list>\n\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/cleaners/templates/main-cleaners.html
// module id = ./src/app/modules/cleaners/templates/main-cleaners.html
// module chunks = main